import './Settings.css';

interface SettingsProps {
  minYear: number
  onYearChange: (e: React.ChangeEvent<HTMLInputElement>) => void
};

function Settings({minYear, onYearChange}: SettingsProps) {
  return (
    <div className="settings-container">
      <div>
        <label>
          <span className="label">
            Origin year
          </span>
          <input type="number" value={minYear} max={new Date().getFullYear()} onChange={onYearChange} />
          <span className="desc">
            Overrides the start year. If data is not available until after the specified year, this value will be ignored.
          </span>
        </label>
      </div>
      <div>

      </div>
    </div>
  );
}

export default Settings;
